import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"
import { Col, Form, Row, Typography } from "antd"

import Flex from "#blocks/Flex"
import { SFormHeader } from "#blocks/Form/formComponents"
import PinGenerator from "#components/PinGenerator"
import { AddUserFormValues } from "#customTypes/composedTypes/userTypes"
import { useGetOneUser } from "#hooks/newHooks/useGetUser"
import { COLORS } from "#styles/colors"

const { Text } = Typography

/**
 * User details tab - includes PIN management
 */
const UserDetails = () => {
  const form = Form.useFormInstance<AddUserFormValues>()
  const userId = Form.useWatch("id", form)
  const user = useGetOneUser(userId)

  return (
    <Flex col gap={40}>
      <Row gutter={16}>
        <Col span={24}>
          <SFormHeader>User Details</SFormHeader>
          <p style={{ color: "#999" }}>
            User details and tasks will be displayed here.
          </p>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <SFormHeader>PIN Management</SFormHeader>
          <Flex center gap={12}>
            {!userId ? (
              <Text type="secondary">Save user to generate PIN</Text>
            ) : !!user?.pinHash ? (
              <>
                <CheckCircleOutlined style={{ color: COLORS.success }} />
                <Text>PIN already set</Text>
              </>
            ) : (
              <>
                <CloseCircleOutlined style={{ color: COLORS.error }} />
                <Text>PIN not set</Text>
              </>
            )}
            <PinGenerator userId={userId} />
          </Flex>
        </Col>
      </Row>
    </Flex>
  )
}

export default UserDetails
